import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button, IconDispatcher } from 'shared/ui-basics/index';
import { useHistory } from 'react-router-dom';

export default function NoDataComponent({ label, icon, fixed = true, backLabel = false }) {
    const { t } = useTranslation()
    const history = useHistory()

    return (
        <div className='full-screen d-flex flex-column' style={{ position: fixed ? 'fixed' : 'relative' }}>
            <WrapperImg>
                {IconDispatcher(icon, 'm-3 mt-0 mb-2', { style: 'light', family:'sharp' })}
            </WrapperImg>
            <CustomContainer>
                {t(label)}
            </CustomContainer>
            {backLabel && <Button variant='primary-outline' size='s' onClick={() => history.push("/journey-map")} className='mt-3'>
                <IconDispatcher type='arrow-left' styling='me-1' />
                {t(backLabel)}
            </Button>}
        </div>)
}
const WrapperImg = styled.div`
svg {
    height:80px;
}`
export const CustomContainer = styled.div`
    width: 50% !important;
    text-align: center;
    font-size: 20px;
`